/**
 * Basic component.
 */
export abstract class Component {
	public onStart = new Set<() => void>();
	public onEnable = new Set<() => void>();
	public onDisable = new Set<() => void>();
	public onDestroy = new Set<() => void>();
	public onUpdate = new Set<() => void>();

	public isDisabled: boolean;
	public abstract state: object;

	constructor(public readonly name: string) {}
}
